import { render, staticRenderFns } from "./CardCarousel.vue?vue&type=template&id=5cd76454&scoped=true"
import script from "./CardCarousel.vue?vue&type=script&lang=js"
export * from "./CardCarousel.vue?vue&type=script&lang=js"
import style0 from "./CardCarousel.vue?vue&type=style&index=0&id=5cd76454&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd76454",
  null
  
)

export default component.exports